export const menuItemType = {
  mono: 'mono',
  other: 'other',
} as const;

export type MenuItemType = typeof menuItemType;

export type MenuItemDetail = {
  link: string;
  text: string;
};

export type MenuItemOfMono = {
  type: MenuItemType['mono'];
  iconName: string;
  heading: string;
  link: string;
};

export type MenuItemOfOther = {
  type: MenuItemType['other'];
  iconName: string;
  heading: string;
  link: string;
  isOpen: boolean;
  details: MenuItemDetail[];
};

export type MenuItem = MenuItemOfMono | MenuItemOfOther;
